// extracted by mini-css-extract-plugin
export default {"wrapper":"xMy2eSHAjgoilq5L2y1l","tooltipButton":"xNQgLj7PqbitskxsvECW"};